var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("dialogs-base", {
    attrs: { show: _setup.dialog, "max-width": "20%" },
    on: {
      "update:show": function ($event) {
        _setup.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-card",
              [
                _c(
                  "v-card-title",
                  {
                    class: [
                      "white--text",
                      "text--darken-3",
                      "redlighten-2",
                      "py-1",
                      "text-subtitle-1",
                      "font-weight-regular",
                      _vm.colorTitle,
                    ],
                  },
                  [
                    _c(
                      "v-icon",
                      { attrs: { left: "", color: "white", small: "" } },
                      [_vm._v(_vm._s(_vm.icon))]
                    ),
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                    _c("v-spacer"),
                  ],
                  1
                ),
                _c("v-card-text", { staticClass: "pa-4" }, [
                  _vm._v(" " + _vm._s(_vm.message) + " "),
                ]),
                _c(
                  "v-card-actions",
                  [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          small: "",
                          color: "grey lighten-2",
                          disabled: _vm.loading,
                        },
                        on: {
                          click: function ($event) {
                            _setup.dialog = false
                          },
                        },
                      },
                      [
                        _vm._v(" Cancelar "),
                        _c(
                          "v-icon",
                          { attrs: { small: "", right: "", dark: "" } },
                          [_vm._v("mdi-close")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          small: "",
                          color: "green",
                          dark: "",
                          loading: _vm.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.emit("confirm")
                          },
                        },
                      },
                      [
                        _vm._v(" Confirmar "),
                        _c(
                          "v-icon",
                          { attrs: { small: "", right: "", dark: "" } },
                          [_vm._v("mdi-check")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }